import { useConst } from '@execonline-inc/react-hooks.private';
import { observer } from 'mobx-react';
import IntercomGuestTooling from '../components/Tooling/IntercomGuestTooling';
import { LoginReactions } from './Reactions';
import { LoginStore } from './Store';
import LoginView from './Views/LoginView';

function Login() {
  const store = useConst(() => new LoginStore());

  return (
    <>
      <LoginView store={store} />
      <LoginReactions store={store} fireImmediately />
      <IntercomGuestTooling />
    </>
  );
}

export default observer(Login);
